import { useState } from "react";
import { Copy, Pencil } from "lucide-react";
import type { InboxReply } from "../types/inbox";

interface Props {
  reply: InboxReply;
}

export const ReplyVariants = ({ reply }: Props) => {
  const [editingLabel, setEditingLabel] = useState<string | null>(null);
  const [editedTexts, setEditedTexts] = useState<Record<string, string>>({});

  const copy = async (text: string) => {
    await navigator.clipboard.writeText(text);
  };

  const getText = (v: InboxReply["variants"][number]) => editedTexts[v.label] ?? v.text;

  return (
    <div className="space-y-2">
      {reply.variants.map((v) => (
        <div key={v.label} className="rounded-lg border border-slate-200 p-3">
          <div className="flex items-center gap-2 mb-1">
            <span className="text-xs font-mono uppercase text-slate-500">{v.label}</span>
            <span className="text-xs text-slate-400">— {v.rationale}</span>
          </div>
          {editingLabel === v.label ? (
            <textarea
              className="w-full text-sm rounded border border-slate-300 p-2"
              defaultValue={getText(v)}
              rows={3}
              onChange={(e) => setEditedTexts((s) => ({ ...s, [v.label]: e.target.value }))}
              onBlur={() => setEditingLabel(null)}
              autoFocus
            />
          ) : (
            <p className="text-sm text-slate-700 whitespace-pre-wrap">{getText(v)}</p>
          )}
          <div className="flex gap-2 mt-2">
            <button
              type="button"
              onClick={() => copy(getText(v))}
              className="text-xs flex items-center gap-1 text-slate-600 hover:text-slate-900"
              aria-label={`Copiar variante ${v.label}`}
            >
              <Copy size={12} /> Copiar
            </button>
            <button
              type="button"
              onClick={() => setEditingLabel(v.label)}
              className="text-xs flex items-center gap-1 text-slate-600 hover:text-slate-900"
              aria-label={`Editar variante ${v.label}`}
            >
              <Pencil size={12} /> Editar
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};
